import {AllSelector} from "./Selector";

const ALL_SELECTOR = new AllSelector()

const selectFilterAndSortSnps = (snpListAnnotatedPreFiltering, {selectors, filters, sort}, myGenome) => {
    /*
    For SNPs table, we want selections from snpListAnnotated.
    Each has the selector(s) that selected it for highlighting why it was selected.

    For the list of selector lozenges, we want how many SNPs selected by that lozenge are displayed (filtered out)

    The results, therefore, are as follows:
    {
      selectedFilteredAndSortedSNPs: [{annotatedSNP, selectors: [...]}],
      selectorCounts: [{selector, filteredSNPsCount, filteredOutSNPsCount}]
    }
     */

    const applyFilters = (snpInterpretation) => !filters["justMyGenomeViewFilter"] || snpInterpretation["rsId_infos"]?.some(rsIdInfo => rsIdInfo?.my_genotype);

    let snpListAnnotated = [];
    // If there are any groupSelectors, apply them to limit snps to those groups
    const groupSelectors = filters["groupsSelectors"];
    let groupFiltersCounts = (groupSelectors?.length ? groupSelectors : [ALL_SELECTOR]).map((selector) => {
        const selections = selector.select(myGenome, snpListAnnotatedPreFiltering);
        const filteredSelections = selections.filter(applyFilters);
        const filteredSNPsCount = filteredSelections?.length || 0;
        const filteredOutSNPsCount = selections.length - filteredSNPsCount;
        filteredSelections.forEach((snpInterpretation) => {
            let found = snpListAnnotated.find((result) => result.snpInterpretation === snpInterpretation);
            if (found) {
                found.bySelectors = [...found.bySelectors, selector];
            } else {
                snpListAnnotated.push(snpInterpretation); // TODO DPB coalesce selectedSnps
            }
        })
        return {selector, filteredSNPsCount, filteredOutSNPsCount}
    });

    let snpsResultList = [];
    let selectorCounts = (selectors?.length ? selectors : [ALL_SELECTOR]).map((selector) => {
        const selections = selector.select(myGenome, snpListAnnotated);
        const filteredSelections = selections.filter(applyFilters);
        const filteredSNPsCount = filteredSelections?.length || 0;
        const filteredOutSNPsCount = selections.length - filteredSNPsCount;
        filteredSelections.forEach((snpInterpretation) => {
            let found = snpsResultList.find((result) => result.snpInterpretation === snpInterpretation);
            if (found) {
                found.bySelectors = [...found.bySelectors, selector];
            } else {
                snpsResultList.push({snpInterpretation, bySelectors: [selector]}); // TODO DPB coalesce selectedSnps
            }
        })
        return {selector, filteredSNPsCount, filteredOutSNPsCount}
    });
    if (sort["alphaBySnpNameSort"]) {
        // Array.sort() sorts "in place" so needed to shallow copy first, which filter() did
        snpsResultList?.sort((a, b) => (a.snpInterpretation.gene_name || a.snpInterpretation.snp_name).localeCompare(b.snpInterpretation.gene_name || b.snpInterpretation.snp_name))
    }
    return {
        selectedFilteredAndSortedSNPs: snpsResultList,
        groupFiltersCounts: groupSelectors.length ? groupFiltersCounts : [],
        selectorCounts: selectors.length ? selectorCounts : []
    };
}

export default selectFilterAndSortSnps;